<div id="passwordResetCard" class="card">
   <h2 color="primary" class="common-normal" *ngIf="userService.user | async as u">
      {{u.fname}} {{u.lname}}
   </h2>

   <form id="resetPasswordForm" [formGroup]="passwordForm">
      <h3>Password Reset</h3>

      <p>New passwords must conform to the following requirements:</p>
      <mat-spinner diameter="69" *ngIf="!validation"></mat-spinner>

      <div id="requirementList" class="requirement" *ngFor="let req of validation">
         <mat-icon id="requirementListInvalid" class="error" *ngIf="newPassword.invalid && checkValidations(req.title)">clear</mat-icon>
         <mat-icon id="requirementListValid" *ngIf="newPassword.valid || (newPassword.invalid && !checkValidations(req.title))">done</mat-icon>
         {{req.text}}
      </div>

      <div id="requirementMatchPassword" class="requirement">
         <mat-icon id="requirementMatchPasswordInvalid" class="error" *ngIf="passwordForm.invalid">clear</mat-icon>
         <mat-icon id="requirementMatchPasswordValid" *ngIf="passwordForm.valid">done</mat-icon>
         Old and New Passwords must not match
      </div>
      <br/>

      <mat-form-field>
         <input id="oldPasswordInput" matInput autofocus type="password" formControlName="oldPassword" placeholder="Old Password" />
      </mat-form-field>

      <mat-form-field>
         <input id="newPasswordInput" matInput type="password" formControlName="newPassword" placeholder="New Password" />
      </mat-form-field>

      <mat-progress-bar id="progressBar" mode="indeterminate" *ngIf="loading"></mat-progress-bar>

      <div id="resetPasswordButtonContainer" class="buttons">
         <button id="resetPasswordButton" mat-raised-button color="primary" type="submit"
            [disabled]="passwordForm.invalid"
            (click)="resetPassword()">
            Reset Password
         </button>
      </div>
   </form>
</div>
